import { Button, Col, PartnerBox, Row, Spinner2, Text } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ContentContainer } from 'screens/Admin/components';

const Partners = (props) => {
  const [loadingButton, setLoadingButton] = useState(null),
    [partners, setPartners] = useState([]),
    isMobile = useSelector((state) => state.appState.isMobile),
    navigate = useNavigate();

  useEffect(() => {
    fetchPartners();
  }, []);

  async function fetchPartners() {
    const res = await Api.get('/admin/getPartners');
    if (!res) return;

    setPartners(res);
  }

  async function removePartner(id) {
    setLoadingButton(id);
    const res = await Api.post(`/admin/removeData`, { type: 'Partner', id });
    setLoadingButton(null);
    if (!res) return;

    setPartners(partners.filter((x) => x._id !== id));
  }

  return (
    <Col center>
      <Text h4>Under development</Text>
    </Col>
  );

  return (
    <Col center>
      <ContentContainer>
        <div className="container">
          {!isMobile && (
            <Col noFlex marg="16px 0 0">
              <Button
                icon="add"
                text="Add partner"
                wid="150px"
                onClick={() => navigate('/admin/add-partner')}
              />
            </Col>
          )}

          <Text h2 marg={isMobile ? '30px 16px 20px' : '30px 0 20px'}>
            Partners
          </Text>

          <div className="wrapped-area">
            {partners.map((x, i) => (
              <div className="content-container">
                <PartnerBox item={x} col="#000" key={i} />

                {!isMobile && (
                  <Row marg="10px 0" between noFlex center>
                    {loadingButton === x._id ? (
                      <Col centerAll wid="80px" noFlex>
                        <Spinner2 spinnerSize="16px" />
                      </Col>
                    ) : (
                      <Button
                        onClick={() => removePartner(x._id)}
                        textButton
                        text="Remove"
                        icon="close"
                        iconCol="red"
                        textCol="red"
                      />
                    )}
                  </Row>
                )}
              </div>
            ))}
          </div>
        </div>
      </ContentContainer>
    </Col>
  );
};

export default Partners;
